<!-- Translated: no -->
<template>
  <div v-if="$store.state.cart.addToOrder && $store.state.cart.addToOrder.number">
    <div class="addon-booking-header brand--bg--dark">
      <a v-if="canRemoveConnection" class="transparent" @click.prevent="removeConnection()" href="#/varukorg">
        <icon name="times-white" :scale="2"></icon>
      </a>
      <a @click.prevent="removeConnection()" href="#/varukorg">
        <span v-if="canRemoveConnection">Avsluta tilläggsbokning</span>
        <span v-if="!canRemoveConnection">Tilläggsbokning</span>
      </a>
      <a class="white number" @click.prevent="openBooking()" href="#/mina-sidor">
        <div>{{ $store.state.cart.addToOrder.number }}</div>
      </a>
    </div>
    <div class="addon-booking-header addon-booking-header--right brand--bg--dark">
      <a class="white" href="#/mina-sidor">
        <i class="fal fa-lock-alt"></i>
        Mina sidor
      </a>
      <a class="white" href="#/varukorg">
        <i class="fal fa-shopping-cart"></i>
        Varukorg
      </a>
      <a href="#modal_live-booking" rel="modal:open">
        <span>Boka online</span>
        <i class="fal fa-chevron-right"></i>
        </a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    add: {
      default: false,
    },
    orderNumber: {
      default: '',
    },
    dateStart: {
      default: null,
    },
    dateEnd: {
      default: null,
    },
    orderNumberNumeric: {
      default: 0,
    },
    helperPool: {
      default: '',
    },
    helperUnit: {
      default: '',
    },
  },
  computed: {
    canRemoveConnection() {
      if (this.$route.name === 'payment') {
        return false;
      }
      if (this.$route.name === 'checkout') {
        return false;
      }
      if (this.$route.name === 'payment confirmation') {
        return false;
      }
      if (this.$route.name === 'payedwithcode') {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'openModal',
      'clearCart',
    ]),
    openBooking() {
      this.$router.push({ name: 'my booking', params: { bookingNumber: this.$store.state.cart.addToOrder.numeric } });
    },
    removeConnection() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: 'Avbryt tilläggsbokning',
        content: 'Du håller just nu på att tilläggsboka. Vill du flytta det du nu har i varukorgen till en egen bokning, eller rensa varukorgen?<br><br>OBS! Oavsett vad du väljer så kommer din grundbokning att finna kvar.',
        buttons: [
          {
            title: 'Flytta till ny bokning',
            class: 'small',
            click: () => {
              $this.$store.state.cart.deliveryTo = {};
              /*eslint-disable */
              for (let i in $this.$store.state.cart.rentals) {
                $this.$store.state.cart.rentals[i].delivery = false;
                $this.$store.state.cart.rentals[i].site = null;
              }
              for (let i in $this.$store.state.cart.skipasses) {
                $this.$store.state.cart.skipasses[i].delivery_type = 'pickup';
                $this.$store.state.cart.skipasses[i].deliveryType = 'pickup';
                $this.$store.state.cart.skipasses[i].site = null;
              }
              /*eslint-enable */
              $this.$store.state.cart.addToOrder = {};
              $this.$store.state.cart.rentalDateRestriction = {};
              $this.closeModal();
              window.location.reload();
            },
          },
          {
            title: 'Rensa varukorg',
            class: 'small white border',
            click: () => {
              $this.clearCart();
              $this.closeModal();
              window.location.reload();
            },
          },
          {
            title: 'Stäng denna ruta',
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
          {
            title: 'Visa min varukorg',
            class: 'small white border',
            click: () => {
              $this.$router.push('/varukorg');
            },
          },
        ],
      }]);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.addon-booking-header
  height 70px
  position absolute
  top 0
  left 0
  width 100vw
  z-index 201
  display flex
  align-items center
  font-family: "Barlow Condensed"

  @media(max-width 838px) {
    top 50px
    height 70px
  }

  & > *
    padding 0 25px
    font-weight bold
    text-transform uppercase
    color white
    display block
    font-size 14px
  .white
    background-color white
    height 100%
    align-items: center;
    display: flex;
    color: inherit
    border-right 1px solid rgba(0, 0, 0, 0.1)
  .transparent
    background-color rgba(255, 255, 255, 0.1)
    height 100%
    align-items: center;
    display: flex;
  .number
    font-size 17px
    font-weight normal
  i, span
    display inline-block
    margin-right 8px

.addon-booking-header--right
  left auto
  right 0
  width auto
  @media(max-width 1110px) {
    display none
  }
</style>



// WEBPACK FOOTER //
// AddonBookingHeader.vue?2e7ebc7e